import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CloseButtonBase = styled(IconButton)`
  align-items: center;
`;

const CloseButton = ({ onClick }) => (
  <CloseButtonBase onClick={onClick}>
    <CloseIcon />
  </CloseButtonBase>
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/modules/common/CloseButton.js